import { AlphaQIcon } from './AlphaQIcon';

/**
 * author: GreenTurtwig
 * id 7DAD6E06-5D6E-4827-A20E-526F2F5AF4C9
 * name alpha-q
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-q.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterQIcon = AlphaQIcon;
export default LetterQIcon